// extracted by css-extract-rspack-plugin
export default {"root":"P0A0ky","fields":"F0tX3O","field":"RHlFJx","actions":"gKH5Y1"};